import React from 'react';
import { MultiSelect as MuiMultiSelect, FormHelperText } from 'e100-react-components';
import { IPropTypes } from 'e100-react-components/lib/components/MultiSelect/types';
import { TOnChangeValue } from 'common/hooks/useMultipleSelectState';

import { useIntl } from 'react-intl';

import StartAdornment from './StartAdornment';
import EndAdornment from './EndAdornment';
import useChange from './hooks/useChange';
import useClasses from './hooks/useClasses';


const MultiSelect = ({
  value,
  items,
  onChange,
  startAdornment,
  placeholder,
  disabled,
  id,
  renderItem,
  progress,
  variant,
  renderValue,
  maxSelectedItems,
  errorMessage,
  applyButtonProps
}: IProps) => {
  const { formatMessage } = useIntl();
  const { classes, multiSelectClasses } = useClasses({ variant });
  const handlerChange = useChange(onChange);

  return (
    <>
      <MuiMultiSelect
        renderValue={renderValue}
        fullWidth
        placeholder={placeholder}
        value={value}
        defaultValue={value}
        items={items}
        onChange={handlerChange}
        showCheckbox
        formatMessage={formatMessage}
        showApplyButton
        disabled={disabled || progress}
        startAdornment={<StartAdornment progress={progress}><>{startAdornment}</></StartAdornment>}
        endAdornment={<EndAdornment value={value} onChange={onChange} />}
        id={id}
        renderItem={renderItem}
        classes={multiSelectClasses}
        maxSelectedItems={maxSelectedItems}
        MenuProps={{
          classes: {
            paper: classes.selectMenu
          },
          anchorOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: -124,
            horizontal: 0
          }
        }}
        applyButtonProps={applyButtonProps}
      />
      {
        errorMessage && (
          <FormHelperText error>{errorMessage}</FormHelperText>
        )
      }
    </>
  );
}

export interface IProps
  extends Pick<
    IPropTypes,
    'value' | 'items' | 'placeholder' | 'startAdornment' | 'renderItem' | 'progress' | 'variant' | 'renderValue' | 'applyButtonProps' | 'maxSelectedItems'
  > {
  onChange: TOnChangeValue;
  disabled?: boolean;
  id?: string;
  startAdornment?: any;
  errorMessage?: string;
}

export default MultiSelect;
